import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class RestService {
  apiurl = 'https://api.alzis.es';
  // apiurl = 'http://localhost/api/acuerdos';

  // Token
  token = '299263FBB42B8CB41579EBC3FB583';
  app_key = '49B14FB10D94A10E48C5DDC75591AF05B4AA156F';
  cls_token = '58148717sagnfcegmewcgad';

  // Login
  // login = this.apiurl + '/usuarios/login.php';
  login = this.apiurl + '/usuarios/login_encrpyt.php';
  permisos = this.apiurl + '/usuarios/permisos.php';

  // ZKTeco
  asignarprioridad = this.apiurl + '/cuadrante/parking/crudZktecoUsers/asignarPrioridad.php';
  dispositivosPorUsuario = this.apiurl + '/cuadrante/parking/crudZktecoUsers/obtenerDispositivosPorUsuario.php';
  usuariosParkingoridad = this.apiurl + '/cuadrante/parking/crudZktecoUsers/obtenerUsuariosParking.php';
  guardarNombreZkUser = this.apiurl + '/cuadrante/parking/crudZktecoUsers/guardarNombreZKUser.php';
  // KPI
  realtimechart = this.apiurl + '/kpi/realtimechart.php';

  // Everis
  everis = this.apiurl + '/everis/listado.php';
  everis_change = this.apiurl + '/everis/change_state.php';
  everis_estados = this.apiurl + '/everis/estados.php';
  everis_estadisticas = this.apiurl + '/everis/estadisticas.php';
  everis_delete_historico = this.apiurl + '/everis/deleteHistorico.php';
  everis_abono = this.apiurl + '/everis/changue_abono.php';

  //Facturacion
  fact_bingos = this.apiurl + '/fact/facturacion_bingos.php';
  bingos_fact = this.apiurl + '/fact/bingos_facturacion.php';
  salas_extras = this.apiurl + '/fact/salas_extras.php';

  // Consumos
  puntos = this.apiurl + '/consumos/puntos.php';
  notification = this.apiurl + '/consumos/notification.php';
  read_notification = this.apiurl + '/consumos/read_notification.php';
  variables = this.apiurl + '/consumos/variables.php';
  edit_variables = this.apiurl + '/consumos/editar_variable.php';
  anadir_suceso = this.apiurl + '/consumos/anadir_suceso.php';
  cron_notification = this.apiurl + '/consumos/variables_cron.php';

  // URLs
  factanualxsala = this.apiurl + '/fact/salafact.php?name_sala=';
  totales = this.apiurl + '/fact/totales.php';
  salafact = this.apiurl + '/fact/salafact.php';

  // ZKRegistry
  get_employees = this.apiurl + '/cuadrante/parking/zkRegistry/empleados.php';
  get_registry_employees = this.apiurl + '/cuadrante/parking/zkRegistry/registrosPorEmpleado.php';

  // Inmuebles
  inmuebles = this.apiurl + '/inmuebles/inmuebles.php';
  error_inmuebles = this.apiurl + '/inmuebles/errors.php';

  // Tipos de BINGOS
  bt = this.apiurl + '/fact/localidad.php';
  b3 = this.apiurl + '/fact/localidad.php';
  b2 = this.apiurl + '/fact/localidad.php';
  ruleta = this.apiurl + '/fact/localidad.php';
  h = this.apiurl + '/fact/localidad.php';
  todos = this.apiurl + '/fact/localidad.php';
  arrurl = this.apiurl + '/fact/clientes.php?';

  // Parking
  parking = this.apiurl + '/parking/parking.php';
  central = this.apiurl + '/parking/central.php';
  ubicaciones = this.apiurl + '/parking/ubicaciones.php';
  ocupacion_parking_day = this.apiurl + '/parking/ocupacion_day.php';
  ocupacion_parking_month = this.apiurl + '/parking/ocupacion_month.php';
  concurrencia = this.apiurl + '/parking/concurrencia.php';
  get_reservas = this.apiurl + '/reservas/getReservas.php';
  state_reservas = this.apiurl + '/reservas/stateReservas.php';
  customer_pay = this.apiurl + '/reservas/CustomerPay.php';
  
  // Arqueapp
  get_pagos_emp = this.apiurl + '/arqueapp/getPagosEMP.php';
  get_pagos_js = this.apiurl + '/arqueapp/getPagosJS.php';
  post_pagos_js = this.apiurl + '/arqueapp/savePagosJS.php';
  post_pagos_emp = this.apiurl + '/arqueapp/savePagosEMP.php';
  get_centros = this.apiurl + '/arqueapp/centros_trabajo.php';
  get_maquinas = this.apiurl + '/arqueapp/maquina_centro.php';

  // Ocupacion
  get_data_js = this.apiurl + '/ocupacion/jefesala.php';
  get_total_entradas = this.apiurl + '/ocupacion/total_entradas.php';

  // Documentacion
  documentation = 'http://10.10.12.78/design/documentacion/api.php';

  // Bingos Fact
  sync = this.apiurl + '/calllogsync/sync.php';
  view = this.apiurl + '/calllogsync/view.php';
  categories = this.apiurl + '/calllogsync/categories.php';
  categorize = this.apiurl + '/calllogsync/categorize.php';
  task = this.apiurl + '/calllogsync/task.php';

  // Events
  eventos = this.apiurl + '/events/index.php';
  slave = this.apiurl + '/events/slave.php';
  eject = this.apiurl + '/events/ejecquery.php';
  report = this.apiurl + '/events/report.php';

  // Alzistencia
  notificaciones = this.apiurl + '/alzistencia/getNotificaciones.php';
  presencial = this.apiurl +'/reservas/controlpresencial.php';

  // Bingos Fact
  rangos = this.apiurl + '/bingosfact/rangos.php';
  data = this.apiurl + '/bingosfact/data.php';
  dataPlaza = this.apiurl + '/bingosfact/dataPlaza.php';
  dataBalisa = this.apiurl + '/bingosfact/dataBalisa.php';

  default = this.apiurl + '/bingosfact/default.php';
  fecha_comparacion = this.apiurl + '/bingosfact/fecha_comparacion.php';
  rangoshora = this.apiurl + '/bingosfact/facturacion_rangohoras.php';

  //Control Presencial
  alzistencia = this.apiurl + '/alzistencia/control.php';

  // Cuadrante PARKING
  cuadrante_parking = this.apiurl + '/cuadrante/parking/data.php';
  cuadranteParkingMetaDatos = this.apiurl + '/cuadrante/parking/metaDatos.php';
  turnos_parking = this.apiurl + '/cuadrante/parking/turnos.php';
  changes_parking = this.apiurl + '/cuadrante/parking/changes.php';
  categorias_emp_parking = this.apiurl + '/cuadrante/parking/categorias.php';
  deleteMode = this.apiurl + '/cuadrante/parking/deleteMode.php';
  reportExcel = this.apiurl + '/cuadrante/parking/report.php';
  years = this.apiurl + '/cuadrante/parking/years.php';
  yearsCentro = this.apiurl + '/cuadrante/parking/yearsCentro.php';
  month = this.apiurl + '/cuadrante/parking/month.php';
  days = this.apiurl + '/cuadrante/parking/days.php';
  editregistry = this.apiurl + '/cuadrante/parking/zkRegistry/editRegistry.php';
  newregistry = this.apiurl + '/cuadrante/parking/zkRegistry/newRegistry.php';
  deleteRegistry = this.apiurl + '/cuadrante/parking/zkRegistry/deleteRegistry.php';
  estadosCuadranteParking = this.apiurl + '/cuadrante/parking/estados.php';
  observaciones = this.apiurl + '/cuadrante/parking/observaciones.php';

  // Cuadrante
  cuadrante = this.apiurl + '/cuadrante/data.php';
  turnos = this.apiurl + '/cuadrante/turnos.php';
  changes = this.apiurl + '/cuadrante/changes.php';
  create_turno = this.apiurl + '/cuadrante/create_turno.php';
  categorias_emp = this.apiurl + '/cuadrante/categorias.php';
  duplicate = this.apiurl + '/cuadrante/duplicate.php';
  sumatorios = this.apiurl + '/cuadrante/sumatorios.php';

  // ERI
  produccion = this.apiurl + '/eri/produccion.php';
  produccion_total = this.apiurl + '/eri/produccion_total.php';
  incidencias = this.apiurl + '/eri/incidencias.php';

  // DISCOTECAS
  ventas = this.apiurl + '/discotecas/ventas.php';

  // ACUERDOS
  proveedores = this.apiurl + '/acuerdos/proveedores.php';
  crear_acuerdo = this.apiurl + '/acuerdos/crear_acuerdo.php';
  crear_articulo_acuerdo = this.apiurl + '/acuerdos/crear_articulo.php';
  articulos = this.apiurl + '/acuerdos/articulos.php';
  añadidos = this.apiurl + '/acuerdos/valores.php';
  datos = this.apiurl + '/acuerdos/datos.php';
  actualizar = this.apiurl + '/acuerdos/actualizar.php';
  sumar_valores = this.apiurl + '/acuerdos/sumar_valores.php';
  eliminar_valores = this.apiurl + '/acuerdos/eliminar_valores.php';
  borrar  = this.apiurl + '/acuerdos/borrar.php';
  borrar_acuerdo  = this.apiurl + '/acuerdos/borrar_acuerdo.php';
  nuevas_fecha_acuerdo  = this.apiurl + '/acuerdos/nuevas_fecha_acuerdo.php';
  obtener_valores_brutos  = this.apiurl + '/acuerdos/obtener_valores_brutos.php';
  cambiar_fecha_valores  = this.apiurl + '/acuerdos/cambiar_fecha_valores.php';
  

  constructor(
    public http: HttpClient,
    public user: UserService) { }


  getProveedores() { return this.http.get(this.proveedores); }

  GetDatos(){ return this.http.get(this.datos); }

  // ZKTeco
  ObtenerDispositivosPorUsuario(user_id){
    const formdata = new FormData();
    formdata.append('user_id', user_id);

    return this.http.post(this.dispositivosPorUsuario, formdata);
  }

  ObtenerUsuariosParking(){
    return this.http.get(this.usuariosParkingoridad);
  }

  AsignarPrioridad(prioridad,userDeviceId,order){
    const formdata = new FormData();
    formdata.append('prioridad', prioridad);
    formdata.append('userDeviceId', userDeviceId);
    formdata.append('order', order);

    return this.http.post(this.asignarprioridad, formdata);
  }

  GuardarNombre(id,nombre){
    const formdata = new FormData();
    formdata.append('id', id);
    formdata.append('nombre', nombre);

    return this.http.post(this.guardarNombreZkUser, formdata);
  }

  GuardarObservacion(observacion,fecha,parking_id){
    const formdata = new FormData();
    formdata.append('observacion', observacion);
    formdata.append('fecha', fecha);
    formdata.append('parking_id', parking_id);

    return this.http.post(this.observaciones, formdata);
  }


  getArticulosPorProveedor(familia_id) {
    const formdata = new FormData();
    formdata.append('familia_id', familia_id);

    return this.http.post(this.articulos, formdata);
  }

  ActualizarArticuloAcuerdo(id,aportacion,unidades) {
    const formdata = new FormData();
    formdata.append('id', id);
    formdata.append('aportacion', aportacion);
    formdata.append('unidades', unidades);

    return this.http.post(this.actualizar, formdata);
  }

  BorrarArticuloAcuerdo(id) {
    const formdata = new FormData();
    formdata.append('id', id);

    return this.http.post(this.borrar, formdata);
  }

  NuevasFechasAcuerdo(inicio,limite,acuerdo_id) {
    const formdata = new FormData();
    formdata.append('inicio', inicio);
    formdata.append('limite', limite);
    formdata.append('acuerdo_id', acuerdo_id);

    return this.http.post(this.nuevas_fecha_acuerdo, formdata);
  }

  BorrarAcuerdo(id) {
    const formdata = new FormData();
    formdata.append('id', id);

    return this.http.post(this.borrar_acuerdo, formdata);
  }

  SumarValores(articulo_acuerdo_id,unidades){
    const formdata = new FormData();
    formdata.append('unidades', unidades);
    formdata.append('articulo_acuerdo_id', articulo_acuerdo_id);

    return this.http.post(this.sumar_valores, formdata);
  }

  CambiarFechaValores(id,fecha) {
    const formdata = new FormData();
    formdata.append('id', id);
    formdata.append('fecha', fecha);

    return this.http.post(this.cambiar_fecha_valores, formdata);
  }

  ObtenerValoresBrutos(acuerdo_id){
    const formdata = new FormData();
    formdata.append('acuerdo_id', acuerdo_id);

    return this.http.post(this.obtener_valores_brutos, formdata);
  }

  EliminarValores(id){
    const formdata = new FormData();
    formdata.append('id', id);

    return this.http.post(this.eliminar_valores, formdata);
  }

  CrearAcuerdo(proveedor_id,fechaInicio,fechaFin) {
    const formdata = new FormData();
    formdata.append('proveedor_id', proveedor_id);
    formdata.append('fechaInicio', fechaInicio);
    formdata.append('fechaFin', fechaFin);

    return this.http.post(this.crear_acuerdo, formdata);
  }

  CrearArticuloAcuerdo(relPack,aportacion,unidades,acuerdo_id) {
    const formdata = new FormData();
    formdata.append('relPack', relPack);
    formdata.append('aportacion', aportacion);
    formdata.append('unidades', unidades);
    formdata.append('acuerdo_id', acuerdo_id);

    return this.http.post(this.crear_articulo_acuerdo, formdata);
  }

  Añadir(relPack,unidades) {
    const formdata = new FormData();
    formdata.append('relPack', relPack);
    formdata.append('unidades', unidades);

    return this.http.post(this.añadidos, formdata);
  }

  getUbicaciones(){
    const data = { 'token': this.token };
    return this.http.get(this.ubicaciones, { params: data});
  }

  postPagosEMP(valor, maquina_id) {
    const formdata = new FormData();
    formdata.append('valor', valor);
    formdata.append('maquina_id', maquina_id);
    formdata.append('token', this.token);

    return this.http.post(this.post_pagos_emp, formdata);
  }

  postPagosJS(valor, maquina_id) {

    const formdata = new FormData();
    formdata.append('valor', valor);
    formdata.append('maquina_id', maquina_id);
    formdata.append('token', this.token);

    return this.http.post(this.post_pagos_js, formdata);
  }

  getCentros() {
    const data = {
      'token': this.token
    };
    return this.http.get(this.get_centros, { params: data});
  }

  getMaquinaXCentro(centro_id) {
    const data = {
      'token': this.token,
      'centro_id' : centro_id
    };
    return this.http.get(this.get_maquinas, { params: data});
  }

  getPagosEmp() {
    const data = {
      'token': this.token
    };
    return this.http.get(this.get_pagos_emp, { params: data});
  }

  getPagosJS() {
    const data = {
      'token': this.token
    };
    return this.http.get(this.get_pagos_js, { params: data});
  }

  // IONICPART
  getsala(name_sala) {
    const data = {
      'token': this.token,
      'name_sala' : name_sala
    };
    return this.http.get(this.salafact, { params: data});
  }

  getsalafact(fecha) {
    const data = {
      'token': this.token,
      'fecha' : fecha
    };
    return this.http.get(this.totales, { params: data});
  }

  getBingo(fdesde, fhasta, periodo, bingo) {
    const data = {
      'token': this.token,
      'periodo' : periodo,
      'fdesde': fdesde,
      'fhasta': fhasta,
      'tipo_bingo': bingo
    };
    return this.http.get(this.bt, { params: data });
  }

  getarray() {
    const data = {
      'token': this.token,
      'agrupacion' : 'mes',
      'fdesde': '2018-01-01',
      'fhasta': '2018-09-01'
    };

    return this.http.get(this.arrurl, { params: data });
  }

  getDataParking(fdesde, fhasta, codins) {
    const data = {
      'token': this.token,
      'fdesde': fdesde,
      'codins': codins,
      'fhasta': fhasta
    };
    return this.http.get(this.parking, { params: data });
  }

  getFacturacionBingos(sala,fdesde, fhasta,) {
    const data = {
      'token': this.token,
      'fdesde': fdesde,
      'fhasta': fhasta,
      'sala': sala
    };
    return this.http.get(this.fact_bingos, { params: data });
  }

  getBingosFacturacion(fdesde, fhasta) {
    const data = {
      'token': this.token,
      'fdesde': fdesde,
      'fhasta': fhasta
    };
    return this.http.get(this.bingos_fact, { params: data });
  }

  getSalas() {
    const data = {
      'token': this.token,
    };
    return this.http.get(this.salas_extras, { params: data });
  }

  getCustomersParking(fdesde, fhasta,ubicacion) {
    const data = {
      'token': this.token,
      'fdesde': fdesde,
      'fhasta': fhasta,
      'ubicacion': ubicacion
    };
    return this.http.get(this.central, { params: data });
  }

  getGeolocation(results, tipo, ciudad, alquilado, label, zona) {
    const data = {
      'token': this.token,
      'results' : results,
      'tipo': tipo,
      'ciudad': ciudad,
      'alquilado': alquilado,
      'label': label,
      'zona': zona
    };

    return this.http.get(this.inmuebles, { params: data});
  }

  getErrors(error_type, tipo = '') {
    const data = {
      'token': this.token,
      'error': error_type,
      'tipo': tipo
    };

    return this.http.get(this.error_inmuebles, { params: data});
  }

  getPuntos(value) {
    const data = {
      'token': this.token,
      'year': value };

    return this.http.get(this.puntos, { params: data});
  }

  getNotifications(value) {
    const data = {
      'token': this.token,
      'priority': value
    };

    return this.http.get(this.notification, { params: data});
  }

  getCron_Notification() {
    const data = { 'token': this.token };

    return this.http.get(this.cron_notification, { params: data});
  }

  getVariables() {
    const data = { 'token': this.token };
    return this.http.get(this.variables, { params: data });
  }

  postVariables(id, valor) {
    const formdata = new FormData();
    formdata.append('id', id);
    formdata.append('valor', valor);
    formdata.append('token', this.token);
    return this.http.post(this.edit_variables, formdata);
  }

  postHistorial(historial, id_cliente, date) {
    const formdata = new FormData();
    formdata.append('historial', historial);
    formdata.append('id_cliente', id_cliente);
    formdata.append('date', date);
    formdata.append('token', this.token);
    return this.http.post(this.anadir_suceso, formdata);
  }

  postLogin(email, password) {
    const formdata = new FormData();
    formdata.append('email', email);
    formdata.append('password', password);
    formdata.append('token', this.token);
    return this.http.post(this.login, formdata);
  }

  postPermisos(id) {
    const formdata = new FormData();
    formdata.append('id', id);
    formdata.append('token', this.token);

    return this.http.post(this.permisos, formdata);
  }

  getListadoEveris() {
    const formdata = new FormData();
    formdata.append('token', this.token);
    return this.http.post(this.everis, formdata);
  }

  postChangeStateEveris(id, new_estado?, state?) {
    const formdata = new FormData();
    formdata.append('id', id);
    if (new_estado != null) {
      formdata.append('new_estado', new_estado);
    }
    formdata.append('token', this.token);
    if (state) {
      formdata.append('estado', state);
    }
    return this.http.post(this.everis_change, formdata);
  }

  postGetEstados_Everis() {
    const formdata = new FormData();
    formdata.append('token', this.token);
    return this.http.post(this.everis_estados, formdata);
  }

  postChangue_Abono(id, value) {

    const formdata = new FormData();
    formdata.append('token', this.token);
    formdata.append('id', id);
    formdata.append('abono', value);
    return this.http.post(this.everis_abono, formdata);

  }

  postGetEstadisticas_Everis() {
    const formdata = new FormData();
    formdata.append('token', this.token);
    return this.http.post(this.everis_estadisticas, formdata);
  }

  deleteHistorico(id_historico) {
    const formdata = new FormData();
    formdata.append('token', this.token);
    formdata.append('id_historico', id_historico);
    return this.http.post(this.everis_delete_historico, formdata);
  }

  postReadNotification(id) {
    const formdata = new FormData();
    formdata.append('id', id);
    formdata.append('token', this.token);
    return this.http.post(this.read_notification, formdata);
  }

  getKPI(id_sala, operador, fecha) {
    const data = {
      'token': this.token,
      'id_sala': id_sala,
      'operador': operador,
      'fecha': fecha
    }

    return this.http.get(this.realtimechart, { params: data });
  }

  getJefeSalaData(desde,hasta){

    const formdata = new FormData();
      formdata.append('desde', desde);
      formdata.append('hasta', hasta);
      formdata.append('token', this.token);
      formdata.append('sala_id', this.user.sala_id);

      return this.http.post(this.get_data_js, formdata);
  }



  getTotalEntradas(desde,hasta){
    const formdata = new FormData();
    formdata.append('desde', desde);
    formdata.append('hasta', hasta);
    formdata.append('token', this.token);
    formdata.append('sala_id', this.user.sala_id);

    return this.http.post(this.get_total_entradas, formdata);
  }

  getOcupationDay(desde,hasta,codins) {
    const formdata = new FormData();
      formdata.append('desde', desde);
      formdata.append('hasta', hasta);
      formdata.append('codins', codins);
      formdata.append('token', this.token);

      return this.http.post(this.ocupacion_parking_day, formdata);
  }

  getOcupationMonth(desde,hasta,codins) {
    const formdata = new FormData();
      formdata.append('desde', desde);
      formdata.append('hasta', hasta);
      formdata.append('codins', codins);
      formdata.append('token', this.token);

      return this.http.post(this.ocupacion_parking_month, formdata);
  }

  getReservas() {
    const formdata = new FormData();
      formdata.append('token', this.token);
      formdata.append('parking_id', this.user.parking_id);
      return this.http.post(this.get_reservas, formdata);
  }

  getEmployees(parking_id) {
    const formdata = new FormData();
 
      formdata.append('parking_id', parking_id);

      return this.http.post(this.get_employees, formdata);
  }

  getRegistryEmployees(zk_user_device_id,year,month,day) {
    const formdata = new FormData();
 
      formdata.append('zk_user_device_id', zk_user_device_id);
      formdata.append('year', year);
      formdata.append('month', month);
      formdata.append('day', day);

      return this.http.post(this.get_registry_employees, formdata);
  }

  state(id,estado) {
    const formdata = new FormData();
      formdata.append('id', id);
      formdata.append('estado', estado);
      formdata.append('token', this.token);
      return this.http.post(this.state_reservas, formdata);
  }

  CustomerPay(id,precio) {
    const formdata = new FormData();
      formdata.append('id', id);
      formdata.append('precio', precio);
      formdata.append('token', this.token);
      return this.http.post(this.customer_pay, formdata);
  }

  getConcurrenciaAbonos(desde,hasta,codins) {
    const formdata = new FormData();
      formdata.append('desde', desde);
      formdata.append('hasta', hasta);
      formdata.append('codins', codins);
      formdata.append('token', this.token);

      return this.http.post(this.concurrencia, formdata);
  }

  // CALL LOG SYNC APP
  GetView() {
    const headersData = new HttpHeaders()
      .append('Authorization', 'Bearer ' + this.cls_token);

    const formdata = new FormData();
    formdata.append('app_key', this.app_key );

    return this.http.post(this.view, formdata,  { headers: headersData });
  }

  GetCategories() {
    const headersData = new HttpHeaders()
      .append('Authorization', 'Bearer ' + this.cls_token);

    const formdata = new FormData();
    formdata.append('app_key', this.app_key );

    return this.http.post(this.categories, formdata,  { headers: headersData });
  }

  PostCategorize( call_log_id, category_id) {
    const headersData = new HttpHeaders()
    .append('Authorization', 'Bearer ' + this.cls_token);

    const formdata = new FormData();
    formdata.append('app_key', this.app_key );
    formdata.append('call_log_id', call_log_id );
    formdata.append('category_id', category_id );

    return this.http.post(this.categorize, formdata,  { headers: headersData });
  }

  /*AddTask(description, call_log_id){
    const headersData = new HttpHeaders()
    .append('Authorization', 'Bearer ' + this.cls_token);

    const formdata = new FormData();
    formdata.append('app_key', this.app_key );
    formdata.append('call_log_id', call_log_id );
    formdata.append('description', description );


    return this.http.post(this.task, formdata,  { headers: headersData });
  }*/

  GetDocumentation() {
    return this.http.get(this.documentation);
  }

  GetEvents() {
    return this.http.get(this.eventos);
  }

  GetSlave() {
    return this.http.get(this.slave);
  }

  // ALzistencia
  getCtrlPresencial() {
    return this.http.get(this.presencial + '?token' + this.token);
  }

  GetNotificaciones() {
    return this.http.get(this.notificaciones);
  }

  // Bingos Fact
  GetRangos() { return this.http.get(this.rangos); }

  Getfecha_comparacion(fecha_comp) {

    const formdata = new FormData();
    formdata.append('app_key', this.app_key );
    formdata.append('fecha_comp', fecha_comp );

    return this.http.post(this.fecha_comparacion, formdata);
  }

  GetDefault() { return this.http.get(this.default); }

  GetData (rango,fecha_single,fecha_comp) {

    const formdata = new FormData();
    formdata.append('rango', rango );
    formdata.append('fecha_single', fecha_single );
    formdata.append('fecha_comp', fecha_comp );

    return this.http.post(this.data, formdata);
  }

  GetDataPlaza (rango,fecha_single,fecha_comp) {

    const formdata = new FormData();
    formdata.append('rango', rango );
    formdata.append('fecha_single', fecha_single );
    formdata.append('fecha_comp', fecha_comp );

    return this.http.post(this.dataPlaza, formdata);
  }

  GetDataBalisa (rango,fecha_single,fecha_comp) {

    const formdata = new FormData();
    formdata.append('rango', rango );
    formdata.append('fecha_single', fecha_single );
    formdata.append('fecha_comp', fecha_comp );

    return this.http.post(this.dataBalisa, formdata);
  }

  GetAlzistencia() {
    return this.http.get(this.alzistencia);
  }

  PostFix(database, opcion) {

    const formdata = new FormData();
    formdata.append('opcion', opcion );
    formdata.append('Master_Host', database.data['Master_Host'] );
    formdata.append('Master_User', database.data['Master_User'] );
    formdata.append('name', database.database['name'] );
    formdata.append('servername', database.database['servername'] );
    formdata.append('username', database.database['username'] );
    formdata.append('password', database.database['password'] );
    formdata.append('dbname', database.database['dbname'] );

    return this.http.post(this.eject, formdata);

  }

  GetReportDB() { return this.http.get(this.report); }

  // CUADRANTE PARKING
  GetCuadranteParking(month,parking_id,year) {
    const formdata = new FormData();
    formdata.append('month', month );
    formdata.append('parking_id', parking_id);
    formdata.append('year', year);
    return this.http.post(this.cuadrante_parking, formdata);
  }


  getEstadosCuadranteParking(){
    return this.http.get(this.estadosCuadranteParking);
  }


  GetMetaDatos(parking_id) {
    const formdata = new FormData();
    formdata.append('parking_id', parking_id);
    return this.http.post(this.cuadranteParkingMetaDatos, formdata);
  }

  GetReportXLS(month,parking_id,year) {
    const formdata = new FormData();
    formdata.append('month', month );
    formdata.append('parking_id', parking_id);
    formdata.append('year', year);
    return this.http.post(this.reportExcel, formdata);
  }

  getCategoriasParking(parking_id) {

    const formdata = new FormData();
    formdata.append('parking_id', parking_id);

    return this.http.post(this.categorias_emp_parking, formdata);
  }

  PostChangesParking(fecha,empleado_id,turno_id) {

    const formdata = new FormData();
    formdata.append('fecha', fecha );
    formdata.append('empleado_id', empleado_id );
    formdata.append('turno_id', turno_id );
    formdata.append('parking_id', this.user.parking_id);

    return this.http.post(this.changes_parking, formdata);
  }

  getTurnosParking(parking_id) {

    const formdata = new FormData();
    formdata.append('parking_id', parking_id);

    return this.http.post(this.turnos_parking, formdata);
  }

  getYears(zk_user_device_id){
    const formdata = new FormData();
    formdata.append('zk_user_device_id', zk_user_device_id);

    return this.http.post(this.years, formdata);
  }

  getYearsCentro(parking_id){
    const formdata = new FormData();
    formdata.append('parking_id', parking_id);

    return this.http.post(this.yearsCentro, formdata);
  }

  getMonth(zk_user_device_id,year){
    const formdata = new FormData();
    formdata.append('zk_user_device_id', zk_user_device_id);
    formdata.append('year', year);

    return this.http.post(this.month, formdata);
  }

  editRegistry(zk_attendance){

    const headersData = new HttpHeaders()
    .append('Authorization', 'Bearer ' + btoa(this.user.email + ":" + this.user.pass) );

    const formdata = new FormData();
    formdata.append('id', zk_attendance.id);
    formdata.append('timestamp', zk_attendance.timestamp);

    return this.http.post(this.editregistry, formdata, { headers: headersData});
  }

  newRegistry(timestamp,punch,zk_user_device_id){

    const headersData = new HttpHeaders()
    .append('Authorization', 'Bearer ' + btoa(this.user.email + ":" + this.user.pass) );

    const formdata = new FormData();
    formdata.append('timestamp', timestamp);
    formdata.append('punch', punch);
    formdata.append('zk_user_device_id', zk_user_device_id);

    return this.http.post(this.newregistry, formdata, { headers: headersData});
  }

  getDays(zk_user_device_id,month,year){
    const formdata = new FormData();
    formdata.append('zk_user_device_id', zk_user_device_id);
    formdata.append('month', month);
    formdata.append('year', year);

    return this.http.post(this.days, formdata);
  }

  DeleteRegistryZK(zkAttendenceId){

    const headersData = new HttpHeaders()
    .append('Authorization', 'Bearer ' + btoa(this.user.email + ":" + this.user.pass) );

    const formdata = new FormData();
    formdata.append('zkAttendenceId', zkAttendenceId);

    return this.http.post(this.deleteRegistry, formdata, { headers: headersData });
  }

  DeleteDay(parking_id,id_datos) {

    const formdata = new FormData();
    formdata.append('parking_id', parking_id);
    formdata.append('id_datos', id_datos);

    return this.http.post(this.deleteMode, formdata);
  }

  // CUADRANTE BINGOS
  GetCuadrante(month,category) {
    const formdata = new FormData();
    formdata.append('month', month );
    formdata.append('sala_id', this.user.sala_id);
    formdata.append('categoria_id', category);
    return this.http.post(this.cuadrante, formdata);
  }


  getTurnos() {

    const formdata = new FormData();
    formdata.append('sala_id', this.user.sala_id);

    return this.http.post(this.turnos, formdata);
  }

  PostChanges(fecha,empleado_id,turno_id) {

    const formdata = new FormData();
    formdata.append('fecha', fecha );
    formdata.append('empleado_id', empleado_id );
    formdata.append('turno_id', turno_id );
    formdata.append('sala_id', this.user.sala_id);

    return this.http.post(this.changes, formdata);
  }

  CreateTurno(nombre) {

    const formdata = new FormData();
    formdata.append('nombre', nombre );
    formdata.append('sala_id', this.user.sala_id);

    return this.http.post(this.create_turno, formdata);

  }

  getCategorias() {

    const formdata = new FormData();
    formdata.append('sala_id', this.user.sala_id);

    return this.http.post(this.categorias_emp, formdata);
  }

  Duplicate(month) {

    const formdata = new FormData();
    formdata.append('sala_id', this.user.sala_id);
    formdata.append('month', month);

    return this.http.post(this.duplicate, formdata);
  }

  GetProduccion(desde,hasta) {

    const formdata = new FormData();
    formdata.append('desde', desde );
    formdata.append('hasta', hasta );

    return this.http.post(this.produccion, formdata);
  }

  GetProduccionTotal(desde,hasta) {

    const formdata = new FormData();
    formdata.append('desde', desde );
    formdata.append('hasta', hasta );

    return this.http.post(this.produccion_total, formdata);
  }

  GetIncidencias(desde,hasta) {

    const formdata = new FormData();
    formdata.append('desde', desde );
    formdata.append('hasta', hasta );

    return this.http.post(this.incidencias, formdata);
  }

  GetVentas(dia,discoteca_id) {

    const formdata = new FormData();
    formdata.append('discoteca_id', discoteca_id );
    formdata.append('dia', dia );

    return this.http.post(this.ventas, formdata);
  }

  GetTotales(categoria_id) {

    const formdata = new FormData();
    formdata.append('fecha', '2019-01-01' );
    formdata.append('sala_id', this.user.sala_id );
    formdata.append('categoria_id', categoria_id );

    return this.http.post(this.sumatorios, formdata);
  }

  GetFacturacionPorRangosHora(sala_id,fecha_desde, fecha_hasta) {
    const headersData = new HttpHeaders()
    .append('Authorization', 'Bearer ' + this.app_key);

    const formdata = new FormData();
    formdata.append('sala_id', sala_id );
    formdata.append('fecha_desde', fecha_desde );
    formdata.append('fecha_hasta', fecha_hasta );

    return this.http.post(this.rangoshora, formdata , { headers: headersData } );
  }
}
